import { FavouriteDataAdapter } from '../../favourite/common/favourite-data-adapter';
import { FavouriteDataColumn } from '../../favourite/common/favourite-interfaces';
import { TableFavouriteModelComponent } from '../table-favourite-model-component';
import { FavouriteRow, RegularField } from '../types';
import { DataRow } from './types';
import { mapAggregateValues, mapSubvalue, mapRollingAverage, mapTarget } from './compact-cell';
import { mapCell } from './cell';

export const mapRow = (dataAdapter: FavouriteDataAdapter,
  model: TableFavouriteModelComponent,
  columns: FavouriteDataColumn[],
  compactView: boolean,
  row: DataRow[]): FavouriteRow => {

  const {
    isAggrColumn: isAggregationColumn,
    uomColIndex: unitOfMeasureColumnIndex,
    compactColumnIndex,
    aggrColIndex: aggregateColumnIndex,
    aggrRollAvgColIndex: rollingAvarageColumnIndex,
    targetColIndex: targetColumnIndex
  } = dataAdapter;

  const renderInCompactMode = compactView && compactColumnIndex >= 0;

  return {

    ...(renderInCompactMode
      ? {
        aggregateValue: mapAggregateValues(dataAdapter, model, columns, row, compactColumnIndex),
        subValue: mapSubvalue(dataAdapter, model, columns, row, compactColumnIndex),
        rollingAvarage: mapRollingAverage(dataAdapter, model, columns, row, compactColumnIndex),
        target: mapTarget(dataAdapter, model, columns, row, compactColumnIndex)
      }
      : {
        ...(aggregateColumnIndex >= 0 && {
          subValue: mapCell(dataAdapter, model, columns, row[0], aggregateColumnIndex)
        }),
        ...(rollingAvarageColumnIndex >= 0 && {
          rollingAvarage: mapCell(dataAdapter, model, columns, row[0], rollingAvarageColumnIndex)
        }),
        ...(targetColumnIndex >= 0 && {
          target: mapCell(dataAdapter, model, columns, row[0], targetColumnIndex)
        })
      }),

    selectionValues: columns
      .reduce((result, column, columnIndex) => {

        /**
         * Skips aggregated columns, unit of measure column or compact column in compactView mode
         */
        const isAggregateColumn = isAggregationColumn(columns, columnIndex);
        const isCompactColumn = renderInCompactMode && compactColumnIndex === columnIndex;
        const isUnitOfMeasureColumn = columnIndex === unitOfMeasureColumnIndex;

        return isAggregateColumn || isCompactColumn || isUnitOfMeasureColumn
          ? result
          : [
            ...result,
            mapCell(dataAdapter, model, columns, row[0], columnIndex)
          ];
      }, [] as RegularField[])
  };
};
